export function filterCategoryTree(nodes, query) {
  const normalizedQuery = String(query || '')
    .trim()
    .toLowerCase();

  if (!normalizedQuery) {
    return Array.isArray(nodes) ? nodes : [];
  }

  return (Array.isArray(nodes) ? nodes : [])
    .map((node) => {
      const children = filterCategoryTree(node.children, normalizedQuery);
      const haystack = [node.name, node.categoryNumber, node.slug]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

      if (haystack.includes(normalizedQuery) || children.length > 0) {
        return {
          ...node,
          children,
        };
      }

      return null;
    })
    .filter(Boolean);
}

export function flattenCategoryTree(nodes, level = 0) {
  return (Array.isArray(nodes) ? nodes : []).flatMap((node) => [
    {
      ...node,
      level,
    },
    ...flattenCategoryTree(node.children, level + 1),
  ]);
}
